// ===== Types =====

export interface HelpTreeNode {
    id: number;
    parent_id: number | null;
    scope: "public" | "private";
    locale: string;
    type: "section" | "article";
    slug: string;
    full_path: string;
    title: string;
    sort_order: number;
    is_published: boolean;
    has_body: boolean;
    children: HelpTreeNode[];
}

export interface HelpNodeDetail {
    id: number;
    parent_id: number | null;
    scope: "public" | "private";
    locale: string;
    type: "section" | "article";
    slug: string;
    full_path: string;
    title: string;
    body_md: string | null;
    body_html: string | null;
    sort_order: number;
    is_published: boolean;
}

export interface HelpNodePayload {
    parent_id?: number | null;
    scope: "public" | "private";
    locale: string;
    type: "section" | "article";
    slug: string;
    title: string;
    body_md?: string | null;
    body_html?: string | null;
    sort_order?: number;
    is_published?: boolean;
}

export interface HelpTreeParams {
    scope?: "public" | "private";
    locale?: string;
}

// ===== Endpoints =====

export const helpEndpoints = {
    getHelpTree: {
        query: (params: HelpTreeParams | void) => ({
            url: "/admin/help/tree",
            params,
        }),
    },
    getHelpNode: {
        query: (id: number) => ({
            url: `/admin/help/nodes/${id}`,
        }),
    },
    createHelpNode: {
        query: (payload: HelpNodePayload) => ({
            url: "/admin/help/nodes",
            method: "POST",
            body: payload,
        }),
    },
    updateHelpNode: {
        query: (args: { id: number; data: Partial<HelpNodePayload> }) => ({
            url: `/admin/help/nodes/${args.id}`,
            method: "PUT",
            body: args.data,
        }),
    },
    deleteHelpNode: {
        query: (id: number) => ({
            url: `/admin/help/nodes/${id}`,
            method: "DELETE",
        }),
    },
};

export const helpTags = ["HelpTree", "HelpNodes"] as const;

